import { styled } from '@mui/material';

export const BooksSectionWrap = styled('div')(() => ({
	display: 'grid',
	gridTemplateColumns: '1fr',
	gap: '16px',
}));
